export default {
    url: 'support/policy',
    include: ['us', 'za', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa'],
};
